// extracted by mini-css-extract-plugin
export default {"category-list":"CategoryList_category-list__-2tWK"};